import { mutation } from "./mutations";
import { Home } from 'services/home';
import { STORAGE_KEYS } from "../../utils/storageKeys";

const handleError = err => {
  console.log("Error in student action : ", err);
  return err.response || err;
};

// Actions
export const getFeeds = (query) => async dispatch => {
  try {
    const result = await Home.getFeed(query);
    dispatch(mutation.setFeedResult(result?.result || []));
    return result;
  } catch (err) {
    handleError(err);
  }
}
export const bookmarkFeed = (section, story) => async (dispatch) => {
  try {
    dispatch(mutation.updateBookmarkedFeed(section, story));
    return true;
  } catch (err) {
    handleError(err);
  }
};


export const setStartSessionTime = () => async (dispatch) => {
  try {
    const sessionOb = {
      started_at: new Date(),
      ended_at: new Date()
    };
    await Home.callSessionSet(sessionOb);
    dispatch(mutation.setStartSessionTime(new Date()));
    sessionStorage.setItem(STORAGE_KEYS.SESSION_START, JSON.stringify(new Date()))
    return true;
  } catch (err) {
    handleError(err);
  }
}

export const callSessionSet = (sessionOb) => async (dispatch) => {
  try {
    const result = await Home.callSessionSet(sessionOb);
    return true;
  } catch (err) {
    handleError(err);
  }
}

export const checkAndStartSession = () => async (dispatch) => {
  const { storage: LocalStorage } = require("services/config/storage");
  const childListData = LocalStorage.fetch.childData();
  const shouldShowProfile = childListData?.list?.filter((child) => child.school_code !== null)?.length > 1;

  let visited = sessionStorage.getItem(STORAGE_KEYS.VISITED);
  let parsedVisited = false;
  if (visited) parsedVisited = JSON.parse(visited);

  const willShowSelectProfile = shouldShowProfile && !parsedVisited;

  if (!willShowSelectProfile) {
    await dispatch(setStartSessionTime());
  }
}